/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import * as AbsenceActions from '@absences/store/absences.actions';
import { getCurrentAbsence, getSelectableAbsenceClasses } from '@absences/store/absences.selectors';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { AbsenceClass } from '@shared/models';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'app-absence-detail',
    templateUrl: './absence-detail.component.html',
    styleUrls: ['./absence-detail.component.scss'],
    standalone: false
})
export class AbsenceDetailComponent implements OnInit, OnDestroy {
  absenceClasses$: Observable<AbsenceClass[]>;
  absenceForm: UntypedFormGroup;
  absenceSubscription: Subscription;

  constructor(
    private store: Store<State>,
    private formBuilder: UntypedFormBuilder
  ) {
    this.absenceForm = formBuilder.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      class: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.absenceClasses$ = this.store.select(getSelectableAbsenceClasses);
    this.absenceSubscription = this.store.select(getCurrentAbsence).pipe(
      tap(absence => this.absenceForm.patchValue(absence))
    ).subscribe();
  }

  persistAbsence(): void {
    this.store.dispatch(new AbsenceActions.PersistAbsence(this.absenceForm.value));
  }

  ngOnDestroy(): void {
    this.absenceSubscription.unsubscribe();
  }
}
